/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { ErrorMessage, useFormikContext } from 'formik'
import { useServiceContext } from '../root'

interface CustomErrorMessageProps {
  name: string
  isErrMsgAObj?: boolean
  className?: string
}

const CustomErrorMessage: React.FC<CustomErrorMessageProps> = ({
  name,
  isErrMsgAObj = false,
  className = 'text-danger'
}) => {
  const context = useServiceContext()
  const formikContext = useFormikContext()

  if (formikContext.submitCount === 0) {
    return null
  }

  return (
    <ErrorMessage name={name}>
      {(msg: any) => {
        const message = isErrMsgAObj && typeof msg === 'object' ? msg?.name : msg
        return (
          <div className={className} style={{ color: '#f76662' }}>
            {context.service.filter.translate(message)}
          </div>
        )
      }}
    </ErrorMessage>
  )
}

export default CustomErrorMessage

export const ErrorMessageStyled: React.FC<CustomErrorMessageProps & { classesName?: string }> = ({
  name,
  classesName = '',
  isErrMsgAObj = false
}) => {
  // Combine classesName with text-danger (matching old implementation)
  const combinedClassName = classesName ? `${classesName} text-danger` : 'text-danger'
  return <CustomErrorMessage name={name} className={combinedClassName} isErrMsgAObj={isErrMsgAObj} />
}
